import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  initialized: false,
  tabs: [
    {
      tab: 'general',
      label: 'general',
    },
    {
      tab: 'pricing',
      label: 'pricing',
    },
    {
      tab: 'admins',
      label: 'admins',
    },
  ],
  enabled: false,
  questionnaireType: null,
  isAutoArchiveEnabled: false,
  isDisclaimerEnabled: false,
  disclaimerText: '',
  isGenericPreviewEnabled: false,
  genericFormPreviews: [],
  limitAcceptedFormTypes: false,
  questionnaireAcceptedFormTypes: [],
  intakeSchedule: {
    response: { min: null, max: null },
    processing: { min: null, max: null },
  },
  isAutoPricingEnabled: false,
  prices: [],
  adminEmails: [],
}

const organizationQuestionnaireAdminSlice = createSlice({
  name: 'organizationQuestionnaireAdmin',
  initialState,
  reducers: {
    setInitialState: (state, action) => {
      return { ...state, ...action.payload, initialized: true }
    },
    setEnabled: (state, action) => {
      state.enabled = action.payload
    },
    setQuestionnaireType: (state, action) => {
      state.questionnaireType = action.payload
    },
    setIsAutoArchiveEnabled: (state, action) => {
      state.isAutoArchiveEnabled = action.payload
    },
    setIsDisclaimerEnabled: (state, action) => {
      state.isDisclaimerEnabled = action.payload
    },
    setDisclaimerText: (state, action) => {
      state.disclaimerText = action.payload
    },
    setIsGenericPreviewEnabled: (state, action) => {
      state.isGenericPreviewEnabled = action.payload
    },
    setGenericFormPreviews: (state, action) => {
      state.genericFormPreviews = action.payload
    },
    setLimitAcceptedFormTypes: (state, action) => {
      state.limitAcceptedFormTypes = action.payload
    },
    setQuestionnaireAcceptedFormTypes: (state, action) => {
      state.questionnaireAcceptedFormTypes = action.payload
    },
    setIntakeSchedule: (state, action) => {
      state.intakeSchedule = action.payload
    },
    setIsAutoPricingEnabled: (state, action) => {
      state.isAutoPricingEnabled = action.payload
    },
    setAdminEmails: (state, action) => {
      state.adminEmails = action.payload
    },
    addNewPrice: (state, action) => {
      const newPrice = action.payload
      state.prices.push(newPrice)
    },
    updatePrice: (state, action) => {
      const { oldId, updatedPrice } = action.payload
      const itemIndex = state.prices.findIndex((price) => price.id === oldId)
      if (itemIndex !== -1) {
        state.prices[itemIndex] = updatedPrice
      }
    },
    removePrice: (state, action) => {
      const priceId = action.payload
      const itemIndex = state.prices.findIndex((price) => price.id === priceId)
      if (itemIndex !== -1) {
        state.prices.splice(itemIndex, 1)
      }
    },
  },
})

export const {
  setInitialState,
  setEnabled,
  setQuestionnaireType,
  setIsAutoArchiveEnabled,
  setIsDisclaimerEnabled,
  setDisclaimerText,
  setIsGenericPreviewEnabled,
  setGenericFormPreviews,
  setLimitAcceptedFormTypes,
  setQuestionnaireAcceptedFormTypes,
  setIntakeSchedule,
  setIsAutoPricingEnabled,
  addNewPrice,
  updatePrice,
  removePrice,
  setAdminEmails,
} = organizationQuestionnaireAdminSlice.actions
export default organizationQuestionnaireAdminSlice.reducer
